module.exports = __webpack_public_path__ + "img/74e2b633311a8c8494e44190eb0eeb64.png";